<template>
<el-container class="hotellist-main" id="main">
  <publicHeader @setCollapse="setCollapse"></publicHeader>
  <div class="main-content">
    <publicMenu :isCollapse="isCollapse"></publicMenu>
    <div class="content">
      <slot>
        <el-main>
          <div class="main" :style="{minHeight: `${mainMinHeight}px`}">
            <!--搜索结果 开始-->
            <div class="list-search">
              <el-input v-model="searchCond.email" placeholder="Email" style="width: 40%"></el-input>
              <el-select v-model="searchCond.status" placeholder="Account status">
                <el-option v-for="(item, index) in AccountStatus" :key="index" :label="item" :value="index"></el-option>
              </el-select>
              <el-select v-model="searchCond.permissions" placeholder="Account type">
                <el-option v-for="(item, index) in AccessLevel" :key="index" :label="item" :value="index"></el-option>
              </el-select>
              <button type="button" class="hotellist_button" @click="getList()">{{$t('search')}}</button>
              <button type="button" class="hotellist_button addButton" @click="addAccount()">{{$t('addAccount')}}</button>
            </div>
            <div class="list-content">
                <div class="list-info-content">
                  <!-- 列表内容 开始 -->
                  <div class="listTitle">
                    <div style="width: 20%;">Email</div>
                    <div style="width: 12%;">Name</div>
                    <div style="width: 15%;">Type</div>
                    <div style="width: 33%;">Access level</div>
                    <div style="width: 10%;">Status</div>
                    <div style="width: 10%;"></div>
                  </div>
                  <el-skeleton :count="6" animated :loading="cotentShow">
                    <template slot="template">
                      <div style="border-bottom: 1px solid #d2cfcf; height: 95px;">
                        <div style="width: 20%; float: left;">
                          <span style=" font-weight: 650; line-height: 55px;"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span style="font-size: 12px; display: block; height: 30px;">
                            <el-skeleton-item variant="text" style="width: 90%;" />
                          </span>
                        </div>
                        <div style="width: 12%; line-height: 95px;font-size: 12px; float: left;"><el-skeleton-item variant="text" style="width: 100px;" /></div>
                        <div style="width: 15%; line-height: 95px;font-size: 12px; float: left;"><el-skeleton-item variant="text" style="width: 100px;" /></div>
                        <div style="width: 33%; float: left; line-height: 95px;"><el-skeleton-item variant="text" style="width: 100px;" /></div>
                        <div style="width: 10%; float: left; line-height: 95px;"><el-skeleton-item variant="text" style="width: 100px;" /></div>
                        <div style="width: 10%; float: left; line-height: 95px;"><el-skeleton-item variant="text" style="width: 100px;" /></div>
                      </div>
                    </template>
                    <template slot-scope="scoped">
                      <el-card :body-style="{ padding: '0px' }">
                        <div class="listInfo" v-for="value in listInfo" :key="value.id">
                          <div style="width: 20%;">
                            <span style="line-height: 55px;">{{value.email}}</span>
                          </div>
                          <div style="width: 12%; line-height: 55px;font-size: 12px;">{{value.first_name}} {{value.last_name}} </div>
                          <div style="width: 15%; line-height: 55px;font-size: 12px;">
                            <span>{{value.permissionsStr}}</span>
                          </div>
                          <div style="width: 33%; line-height: 55px;font-size: 12px;">
                            <span>{{value.accessLevelStr}}</span>
                          </div>
                          <div style="width: 10%; line-height: 55px;font-size: 12px;">
                            <el-switch @change="changeStatus($event, value)" :value="value.state" active-value="1" inactive-value="2" style="line-height: 55px;font-size: 12px;height: 55px;"></el-switch>
                          </div>
                          <div style="width: 10%;">
                            <button type="button" class="booknow_button editButton" @click="editAccount(value)">Edit</button>
                          </div>
                        </div>
                      </el-card>
                    </template>
                  </el-skeleton>
                <!-- 列表内容 结束 -->
                  <!-- 弹出框组件 -->
                  <el-dialog :visible.sync="dialogVisible" title="Update user">
                    <!-- 表单内容 -->
                    <el-form ref="myForm" :model="formData" label-width="110px">
                      <el-form-item label="User email:">
                        <span v-if="formData.id !== undefined && formData.email.length > 0" v-html="formData.email"></span>
                        <el-input v-else v-model="formData.email" placeholder="Email" ref="email"></el-input>
                      </el-form-item>
                      <el-form-item label="First name:">
                        <el-input v-model="formData.first_name" placeholder="First name" ref="first_name"></el-input>
                      </el-form-item>
                      <el-form-item label="Last name:">
                        <el-input v-model="formData.last_name" placeholder="Last name" ref="last_name"></el-input>
                      </el-form-item>
                      <el-form-item label="Access level:">
                        <el-select v-model="formData.permissions" placeholder="Change access level" ref="permissions">
                          <el-option v-for="(item, index) in AccessLevel" :key="index" :label="item" :value="index"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="Password:" v-if="formData.id === undefined || formData.email.length === 0" :class="passwordClass">
                        <el-input v-model="formData.password" placeholder="Password" ref="password"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="saveAccount">提交</el-button>
                      </el-form-item>
                    </el-form>
                  </el-dialog>
                </div>
            </div>
            <!--搜索结果 结束-->
          </div>
        </el-main>
      </slot>
    </div>
  </div>
  <publicFooter :languageSet="language"></publicFooter>
</el-container>
</template>

<script>
import { accountList } from '@/request/account.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
import publicSearchCond from '@/components/public/publicSearchCond'
import HotelSearchCond from '@/components/hotelsearch/HotelSearchCond'
import FrameQuotation from '@/components/public/frameQuotation.vue'
import {changeStatus} from '../../request/account'
export default {
  name: 'AccountList',
  components: {
    publicFooter,
    publicHeader,
    publicMenu,
    publicSearchCond,
    HotelSearchCond,
    FrameQuotation
  },
  data () {
    return {
      dialogVisible: false,
      formData: {'email': '', 'first_name': '', 'last_name': '', 'permissions': '', 'password': ''},
      AccountStatus: {1: 'Normal', 2: 'Disable'},
      AccessLevel: {1: 'Full Access', 2: 'Booking,Order Management', 3: 'Order Management'},
      searchCond: {'email': '', 'status': '', 'permissions': ''},
      listInfo: [],
      cotentShow: true,
      currentPage: 1, // 当前默认显示第几页
      listTotal: 0, // 分页总条数
      listTotalAll: 0, // 总条数-完全匹配酒店+附近三家+重点酒店+其他酒店
      pageSize: 20, // 每页显示多少条数据，记住这里一定要是10的倍数，不然无效
      allPersonNum: 2,
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      ismobile: false,
      mainMinHeight: document.documentElement.clientHeight - 60 - 241,
      isCollapse: this.common.collapseSet(this),
      contentWidth: document.body.clientWidth - 74,
      personWidth: (document.body.clientWidth - 74) * 0.2182 - 10,
      source: ''
    }
  },
  mounted () {
    // 下滑搜索条置顶
    window.addEventListener('scroll', this.handleScroll)
    this.getList(1)
  },
  destroyed () {
    window.name = ''
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.fromPath = from.path
      var fromname = from.name
      if (fromname !== null) {
        localStorage.setItem('keyword', JSON.stringify({}))
        localStorage.setItem('star', JSON.stringify([]))
        var budgetInfo = {'budget': [], 'budgetSelect': [], 'budgetSelectIds': []}
        localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
        localStorage.setItem('type', 'hot')
        localStorage.setItem('showSort', false)
        localStorage.setItem('showFilter', false)
      }
    })
  },
  methods: {
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    // 分页 size-change  pageSize 改变时会触发 每页条数
    handleSizeChange (val) {
      this.pageSize = val
    },
    // current-change  currentPage 改变时会触发  当前页
    async handleCurrentChange (val) {
      this.start = (val - 1) * this.pageSize // （val-1）是我自己的项目需要，一般写val即可
      localStorage.setItem('page', val)
      this.getList(val)
    },
    stopScroll () {
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', mo, false)
    },
    canScroll () {
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = ''
      document.addEventListener('touchmove', mo, false)
    },
    getList (page) {
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        token = ''
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      this.listInfo = []
      var dataJson = {
        'email': this.searchCond.email,
        'status': this.searchCond.status,
        'permissions': this.searchCond.permissions,
        'page': page,
        'time': time,
        'language': this.language,
        'source': this.source,
        'token': token,
        'operation': 'accountList'
      }
      var data = this.common.encryptionData(dataJson, this)
      accountList(data).then(res => {
        if (res.flag === '200') {
          this.listInfo = res.data.list
          this.listTotal = parseInt(res.data.totalNum)
          localStorage.setItem('total', this.listTotal)
          this.currentPage = parseInt(res.data.currentPage)
          this.pageSize = parseInt(res.data.pageSize)
          this.cotentShow = false
          this.cotentEmptyShow = false
        } else {
          this.cotentShow = false
          this.cotentEmptyShow = true
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    addAccount () {
      this.formData = {'email': '', 'first_name': '', 'last_name': '', 'permissions': '', 'password': ''}
      this.dialogVisible = true
    },
    editAccount (row) {
      this.formData = row
      this.dialogVisible = true
    },
    saveAccount () {
      alert('click')
      if (this.formData.email.length === 0) {
        this.$refs.email.focus()
        return false
      }
      if (this.formData.first_name.length === 0) {
        this.$refs.first_name.focus()
        return false
      }
      if (this.formData.last_name.length === 0) {
        this.$refs.last_name.focus()
        return false
      }
      if (this.formData.permissions.length === 0) {
        this.$refs.permissions.focus()
        return false
      }
      if (this.formData.id === undefined && this.formData.password.length === 0) {
        this.$refs.password.focus()
        return false
      }
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        token = ''
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {
        'userid': this.formData.id !== undefined ? this.formData.id : '',
        'email': this.formData.email,
        'first_name': this.formData.first_name,
        'last_name': this.formData.last_name,
        'permissions': this.formData.permissions,
        'password': this.formData.password !== null ? this.formData.password : '',
        'time': time,
        'source': this.source,
        'token': token,
        'operation': 'save'
      }
      console.log(dataJson)
      var data = this.common.encryptionData(dataJson, this)
      changeStatus(data).then(res => {
        if (res.msg === 'success') {
          this.dialogVisible = false
        } else {
          alert(res.msg)
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    changeStatus (newVal, row) {
      let id = row.id
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        token = ''
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {
        'userid': id,
        'state': newVal,
        'time': time,
        'source': this.source,
        'token': token,
        'operation': 'changeStatus'
      }
      var data = this.common.encryptionData(dataJson, this)
      changeStatus(data).then(res => {
        if (res.msg === 'success') {
          row.state = newVal
        } else {
          alert(res.msg)
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    }
  }
}
</script>

<style scoped>
.hotellist-main /deep/ .el-header {
  position: unset;
}
.content{padding-top:10px;width:95%; min-height:600px;background-color: rgba(242, 242, 242, 1);}
.main{width:100%;}
/* 搜索 */
.list-search{
  margin: 0 auto;
  height: 120px;
  line-height: 120px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  border: 0px none;
  border-radius: 5px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 98%;
  text-align: center;
}
.hotellist_button{cursor: pointer; width:12.28%;height:48px;font-size:16px;background:rgba(51, 51, 51, 1);color:#FFF;border: none;border-radius:5px;}
.hotellist_button:hover, .hotellist_button:focus{background: rgba(241, 81, 27, 1);}
/* 搜索条件 结束 */
.list-content {
  width: 98%;
  margin: 20px auto;
  min-height: 700px;
  background-color: rgba(255, 255, 255, 1);
}
.list-info-content{
  margin: 0 auto;
  padding-top: 10px;
  width: 98%;
  min-height: 600px;
  background-color: #FFF;
  font-size: 16px;
}
.listTitle{
  height: 64px;
  line-height: 64px;
  padding: 0 30px;
  background: inherit;
  background-color: rgba(242, 242, 242, 1);
  border: 0 none;
  border-radius: 5px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  font-weight: 650;
  font-style: normal;
}
.listInfo{
  height: 60px;
  line-height: 60px;
  padding: 0 30px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(215, 215, 215, 1);
  border-left: 0px;
  border-top: 0px;
  border-right: 0px;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.listTitle div, .listInfo div{display: inline-block; float: left;text-align: left;vertical-align: center;}

.editButton {
  width: 88px;
  float: none !important;
}
.addButton {
  width: 191px;
  height: 60px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(83, 102, 163, 1);
  border-radius: 6px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #5366A3;
}

</style>
<style>
.el-drawer__open .el-drawer.btt{height:auto !important;}
</style>



// WEBPACK FOOTER //
// src/components/account/accountList.vue